import parse from "html-react-parser";
import React, { useEffect, useState } from "react";
import { useRef } from "react";
import isEqual from "react-fast-compare";
import { useDispatch, useSelector } from "react-redux";
const RichTextWidget = ({
  data,
  section_index,
  widget_index,
  dashboard,
  PdfDownloadStatus,
  PptGeneratingStatus,
  noteExist,
  chart_type,
  id,
  style,
}) => {
  const noteRef = useRef(null);
  useEffect(() => {}, [noteRef, noteRef?.current?.clientHeight]);
  return (
    <>
      <div
        className={`custom_scroll1 RichText ${
          PdfDownloadStatus ? "p-10" : "p-15"
        }`}
        style={{
          maxHeight: PptGeneratingStatus
            ? "90rem"
            : style?.height
            ? style?.height + "px"
            : "45rem",
          overflow: "auto",
        }}
        id={id}
        ref={noteRef}
      >
        {parse(data)}
      </div>
    </>
  );
};
export default React.memo(RichTextWidget, isEqual);
